export enum MenyProductField {
    name = 1,
    description = 2,
    price = 3,
    categoryName = 4,
    ean = 5,
}
